/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SettingsRouteImport } from './routes/_settings'
import { Route as AppMealPageRouteImport } from './routes/_app/_meal-page'
import { Route as AppRecipePageRouteImport } from './routes/_app/_recipe-page'
import { Route as AppShellRouteImport } from './routes/_app/_shell'
import { Route as AppImportRouteImport } from './routes/_app/import'
import { Route as SettingsAccountRouteImport } from './routes/_settings/account'
import { Route as SettingsAdminRouteImport } from './routes/_settings/admin'
import { Route as SettingsDebugRouteImport } from './routes/_settings/debug'
import { Route as SettingsSettingsRouteImport } from './routes/_settings/settings'
import { Route as AuthPathRouteImport } from './routes/auth/$path'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppShellIndexRouteImport } from './routes/_app/_shell/index'
import { Route as AppShellMealsRouteImport } from './routes/_app/_shell/meals'
import { Route as AppShellRecipesRouteImport } from './routes/_app/_shell/recipes'
import { Route as AppShellShoppingRouteImport } from './routes/_app/_shell/shopping'
import { Route as SettingsAdminUserIdRouteImport } from './routes/_settings/admin_.$userId'
import { Route as AppMealPageMealsDateRouteImport } from './routes/_app/_meal-page/meals.$date'
import { Route as AppRecipePageRecipesRecipeIdRouteImport } from './routes/_app/_recipe-page/recipes.$recipeId'
import { Route as AppRecipePageRecipesFromPhotoRouteImport } from './routes/_app/_recipe-page/recipes.from-photo'
import { Route as AppRecipePageRecipesFromTextRouteImport } from './routes/_app/_recipe-page/recipes.from-text'
import { Route as AppRecipePageRecipesFromWebRouteImport } from './routes/_app/_recipe-page/recipes.from-web'
import { Route as AppRecipePageRecipesNewRouteImport } from './routes/_app/_recipe-page/recipes.new'
import { Route as AppRecipePageRecipesRecipeIdEditRouteImport } from './routes/_app/_recipe-page/recipes.$recipeId_.edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/_settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMealPageRoute = AppMealPageRouteImport.update({
  id: '/_meal-page',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipePageRoute = AppRecipePageRouteImport.update({
  id: '/_recipe-page',
  getParentRoute: () => AppRoute,
} as any)
const AppShellRoute = AppShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => AppRoute,
} as any)
const AppImportRoute = AppImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AppRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAdminRoute = SettingsAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDebugRoute = SettingsDebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsRoute = SettingsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SettingsRoute,
} as any)
const AuthPathRoute = AuthPathRouteImport.update({
  id: '/auth/$path',
  path: '/auth/$path',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppShellIndexRoute = AppShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppShellRoute,
} as any)
const AppShellMealsRoute = AppShellMealsRouteImport.update({
  id: '/meals',
  path: '/meals',
  getParentRoute: () => AppShellRoute,
} as any)
const AppShellRecipesRoute = AppShellRecipesRouteImport.update({
  id: '/recipes',
  path: '/recipes',
  getParentRoute: () => AppShellRoute,
} as any)
const AppShellShoppingRoute = AppShellShoppingRouteImport.update({
  id: '/shopping',
  path: '/shopping',
  getParentRoute: () => AppShellRoute,
} as any)
const SettingsAdminUserIdRoute = SettingsAdminUserIdRouteImport.update({
  id: '/admin_/$userId',
  path: '/admin/$userId',
  getParentRoute: () => SettingsRoute,
} as any)
const AppMealPageMealsDateRoute = AppMealPageMealsDateRouteImport.update({
  id: '/meals/$date',
  path: '/meals/$date',
  getParentRoute: () => AppMealPageRoute,
} as any)
const AppRecipePageRecipesRecipeIdRoute =
  AppRecipePageRecipesRecipeIdRouteImport.update({
    id: '/recipes/$recipeId',
    path: '/recipes/$recipeId',
    getParentRoute: () => AppRecipePageRoute,
  } as any)
const AppRecipePageRecipesFromPhotoRoute =
  AppRecipePageRecipesFromPhotoRouteImport.update({
    id: '/recipes/from-photo',
    path: '/recipes/from-photo',
    getParentRoute: () => AppRecipePageRoute,
  } as any)
const AppRecipePageRecipesFromTextRoute =
  AppRecipePageRecipesFromTextRouteImport.update({
    id: '/recipes/from-text',
    path: '/recipes/from-text',
    getParentRoute: () => AppRecipePageRoute,
  } as any)
const AppRecipePageRecipesFromWebRoute =
  AppRecipePageRecipesFromWebRouteImport.update({
    id: '/recipes/from-web',
    path: '/recipes/from-web',
    getParentRoute: () => AppRecipePageRoute,
  } as any)
const AppRecipePageRecipesNewRoute = AppRecipePageRecipesNewRouteImport.update({
  id: '/recipes/new',
  path: '/recipes/new',
  getParentRoute: () => AppRecipePageRoute,
} as any)
const AppRecipePageRecipesRecipeIdEditRoute =
  AppRecipePageRecipesRecipeIdEditRouteImport.update({
    id: '/recipes/$recipeId_/edit',
    path: '/recipes/$recipeId/edit',
    getParentRoute: () => AppRecipePageRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppShellIndexRoute
  '/import': typeof AppImportRoute
  '/account': typeof SettingsAccountRoute
  '/admin': typeof SettingsAdminRoute
  '/debug': typeof SettingsDebugRoute
  '/settings': typeof SettingsSettingsRoute
  '/auth/$path': typeof AuthPathRoute
  '/invite/$token': typeof InviteTokenRoute
  '/meals': typeof AppShellMealsRoute
  '/recipes': typeof AppShellRecipesRoute
  '/shopping': typeof AppShellShoppingRoute
  '/admin/$userId': typeof SettingsAdminUserIdRoute
  '/meals/$date': typeof AppMealPageMealsDateRoute
  '/recipes/$recipeId': typeof AppRecipePageRecipesRecipeIdRoute
  '/recipes/from-photo': typeof AppRecipePageRecipesFromPhotoRoute
  '/recipes/from-text': typeof AppRecipePageRecipesFromTextRoute
  '/recipes/from-web': typeof AppRecipePageRecipesFromWebRoute
  '/recipes/new': typeof AppRecipePageRecipesNewRoute
  '/recipes/$recipeId/edit': typeof AppRecipePageRecipesRecipeIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof AppShellIndexRoute
  '/import': typeof AppImportRoute
  '/account': typeof SettingsAccountRoute
  '/admin': typeof SettingsAdminRoute
  '/debug': typeof SettingsDebugRoute
  '/settings': typeof SettingsSettingsRoute
  '/auth/$path': typeof AuthPathRoute
  '/invite/$token': typeof InviteTokenRoute
  '/meals': typeof AppShellMealsRoute
  '/recipes': typeof AppShellRecipesRoute
  '/shopping': typeof AppShellShoppingRoute
  '/admin/$userId': typeof SettingsAdminUserIdRoute
  '/meals/$date': typeof AppMealPageMealsDateRoute
  '/recipes/$recipeId': typeof AppRecipePageRecipesRecipeIdRoute
  '/recipes/from-photo': typeof AppRecipePageRecipesFromPhotoRoute
  '/recipes/from-text': typeof AppRecipePageRecipesFromTextRoute
  '/recipes/from-web': typeof AppRecipePageRecipesFromWebRoute
  '/recipes/new': typeof AppRecipePageRecipesNewRoute
  '/recipes/$recipeId/edit': typeof AppRecipePageRecipesRecipeIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_settings': typeof SettingsRouteWithChildren
  '/_app/_meal-page': typeof AppMealPageRouteWithChildren
  '/_app/_recipe-page': typeof AppRecipePageRouteWithChildren
  '/_app/_shell': typeof AppShellRouteWithChildren
  '/_app/import': typeof AppImportRoute
  '/_settings/account': typeof SettingsAccountRoute
  '/_settings/admin': typeof SettingsAdminRoute
  '/_settings/debug': typeof SettingsDebugRoute
  '/_settings/settings': typeof SettingsSettingsRoute
  '/auth/$path': typeof AuthPathRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_app/_shell/meals': typeof AppShellMealsRoute
  '/_app/_shell/recipes': typeof AppShellRecipesRoute
  '/_app/_shell/shopping': typeof AppShellShoppingRoute
  '/_settings/admin_/$userId': typeof SettingsAdminUserIdRoute
  '/_app/_shell/': typeof AppShellIndexRoute
  '/_app/_meal-page/meals/$date': typeof AppMealPageMealsDateRoute
  '/_app/_recipe-page/recipes/$recipeId': typeof AppRecipePageRecipesRecipeIdRoute
  '/_app/_recipe-page/recipes/from-photo': typeof AppRecipePageRecipesFromPhotoRoute
  '/_app/_recipe-page/recipes/from-text': typeof AppRecipePageRecipesFromTextRoute
  '/_app/_recipe-page/recipes/from-web': typeof AppRecipePageRecipesFromWebRoute
  '/_app/_recipe-page/recipes/new': typeof AppRecipePageRecipesNewRoute
  '/_app/_recipe-page/recipes/$recipeId_/edit': typeof AppRecipePageRecipesRecipeIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/import'
    | '/account'
    | '/admin'
    | '/debug'
    | '/settings'
    | '/auth/$path'
    | '/invite/$token'
    | '/meals'
    | '/recipes'
    | '/shopping'
    | '/admin/$userId'
    | '/meals/$date'
    | '/recipes/$recipeId'
    | '/recipes/from-photo'
    | '/recipes/from-text'
    | '/recipes/from-web'
    | '/recipes/new'
    | '/recipes/$recipeId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/import'
    | '/account'
    | '/admin'
    | '/debug'
    | '/settings'
    | '/auth/$path'
    | '/invite/$token'
    | '/meals'
    | '/recipes'
    | '/shopping'
    | '/admin/$userId'
    | '/meals/$date'
    | '/recipes/$recipeId'
    | '/recipes/from-photo'
    | '/recipes/from-text'
    | '/recipes/from-web'
    | '/recipes/new'
    | '/recipes/$recipeId/edit'
  id:
    | '__root__'
    | '/_app'
    | '/_settings'
    | '/_app/_meal-page'
    | '/_app/_recipe-page'
    | '/_app/_shell'
    | '/_app/import'
    | '/_settings/account'
    | '/_settings/admin'
    | '/_settings/debug'
    | '/_settings/settings'
    | '/auth/$path'
    | '/invite/$token'
    | '/_app/_shell/meals'
    | '/_app/_shell/recipes'
    | '/_app/_shell/shopping'
    | '/_settings/admin_/$userId'
    | '/_app/_shell/'
    | '/_app/_meal-page/meals/$date'
    | '/_app/_recipe-page/recipes/$recipeId'
    | '/_app/_recipe-page/recipes/from-photo'
    | '/_app/_recipe-page/recipes/from-text'
    | '/_app/_recipe-page/recipes/from-web'
    | '/_app/_recipe-page/recipes/new'
    | '/_app/_recipe-page/recipes/$recipeId_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  AuthPathRoute: typeof AuthPathRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_settings': {
      id: '/_settings'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_meal-page': {
      id: '/_app/_meal-page'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppMealPageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_recipe-page': {
      id: '/_app/_recipe-page'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRecipePageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_shell': {
      id: '/_app/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppShellRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/import': {
      id: '/_app/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AppImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_settings/account': {
      id: '/_settings/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/admin': {
      id: '/_settings/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof SettingsAdminRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/debug': {
      id: '/_settings/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof SettingsDebugRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings': {
      id: '/_settings/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsSettingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/auth/$path': {
      id: '/auth/$path'
      path: '/auth/$path'
      fullPath: '/auth/$path'
      preLoaderRoute: typeof AuthPathRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_shell/': {
      id: '/_app/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppShellIndexRouteImport
      parentRoute: typeof AppShellRoute
    }
    '/_app/_shell/meals': {
      id: '/_app/_shell/meals'
      path: '/meals'
      fullPath: '/meals'
      preLoaderRoute: typeof AppShellMealsRouteImport
      parentRoute: typeof AppShellRoute
    }
    '/_app/_shell/recipes': {
      id: '/_app/_shell/recipes'
      path: '/recipes'
      fullPath: '/recipes'
      preLoaderRoute: typeof AppShellRecipesRouteImport
      parentRoute: typeof AppShellRoute
    }
    '/_app/_shell/shopping': {
      id: '/_app/_shell/shopping'
      path: '/shopping'
      fullPath: '/shopping'
      preLoaderRoute: typeof AppShellShoppingRouteImport
      parentRoute: typeof AppShellRoute
    }
    '/_settings/admin_/$userId': {
      id: '/_settings/admin_/$userId'
      path: '/admin/$userId'
      fullPath: '/admin/$userId'
      preLoaderRoute: typeof SettingsAdminUserIdRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_app/_meal-page/meals/$date': {
      id: '/_app/_meal-page/meals/$date'
      path: '/meals/$date'
      fullPath: '/meals/$date'
      preLoaderRoute: typeof AppMealPageMealsDateRouteImport
      parentRoute: typeof AppMealPageRoute
    }
    '/_app/_recipe-page/recipes/$recipeId': {
      id: '/_app/_recipe-page/recipes/$recipeId'
      path: '/recipes/$recipeId'
      fullPath: '/recipes/$recipeId'
      preLoaderRoute: typeof AppRecipePageRecipesRecipeIdRouteImport
      parentRoute: typeof AppRecipePageRoute
    }
    '/_app/_recipe-page/recipes/from-photo': {
      id: '/_app/_recipe-page/recipes/from-photo'
      path: '/recipes/from-photo'
      fullPath: '/recipes/from-photo'
      preLoaderRoute: typeof AppRecipePageRecipesFromPhotoRouteImport
      parentRoute: typeof AppRecipePageRoute
    }
    '/_app/_recipe-page/recipes/from-text': {
      id: '/_app/_recipe-page/recipes/from-text'
      path: '/recipes/from-text'
      fullPath: '/recipes/from-text'
      preLoaderRoute: typeof AppRecipePageRecipesFromTextRouteImport
      parentRoute: typeof AppRecipePageRoute
    }
    '/_app/_recipe-page/recipes/from-web': {
      id: '/_app/_recipe-page/recipes/from-web'
      path: '/recipes/from-web'
      fullPath: '/recipes/from-web'
      preLoaderRoute: typeof AppRecipePageRecipesFromWebRouteImport
      parentRoute: typeof AppRecipePageRoute
    }
    '/_app/_recipe-page/recipes/new': {
      id: '/_app/_recipe-page/recipes/new'
      path: '/recipes/new'
      fullPath: '/recipes/new'
      preLoaderRoute: typeof AppRecipePageRecipesNewRouteImport
      parentRoute: typeof AppRecipePageRoute
    }
    '/_app/_recipe-page/recipes/$recipeId_/edit': {
      id: '/_app/_recipe-page/recipes/$recipeId_/edit'
      path: '/recipes/$recipeId/edit'
      fullPath: '/recipes/$recipeId/edit'
      preLoaderRoute: typeof AppRecipePageRecipesRecipeIdEditRouteImport
      parentRoute: typeof AppRecipePageRoute
    }
  }
}

interface AppMealPageRouteChildren {
  AppMealPageMealsDateRoute: typeof AppMealPageMealsDateRoute
}

const AppMealPageRouteChildren: AppMealPageRouteChildren = {
  AppMealPageMealsDateRoute: AppMealPageMealsDateRoute,
}

const AppMealPageRouteWithChildren = AppMealPageRoute._addFileChildren(
  AppMealPageRouteChildren,
)

interface AppRecipePageRouteChildren {
  AppRecipePageRecipesRecipeIdRoute: typeof AppRecipePageRecipesRecipeIdRoute
  AppRecipePageRecipesFromPhotoRoute: typeof AppRecipePageRecipesFromPhotoRoute
  AppRecipePageRecipesFromTextRoute: typeof AppRecipePageRecipesFromTextRoute
  AppRecipePageRecipesFromWebRoute: typeof AppRecipePageRecipesFromWebRoute
  AppRecipePageRecipesNewRoute: typeof AppRecipePageRecipesNewRoute
  AppRecipePageRecipesRecipeIdEditRoute: typeof AppRecipePageRecipesRecipeIdEditRoute
}

const AppRecipePageRouteChildren: AppRecipePageRouteChildren = {
  AppRecipePageRecipesRecipeIdRoute: AppRecipePageRecipesRecipeIdRoute,
  AppRecipePageRecipesFromPhotoRoute: AppRecipePageRecipesFromPhotoRoute,
  AppRecipePageRecipesFromTextRoute: AppRecipePageRecipesFromTextRoute,
  AppRecipePageRecipesFromWebRoute: AppRecipePageRecipesFromWebRoute,
  AppRecipePageRecipesNewRoute: AppRecipePageRecipesNewRoute,
  AppRecipePageRecipesRecipeIdEditRoute: AppRecipePageRecipesRecipeIdEditRoute,
}

const AppRecipePageRouteWithChildren = AppRecipePageRoute._addFileChildren(
  AppRecipePageRouteChildren,
)

interface AppShellRouteChildren {
  AppShellMealsRoute: typeof AppShellMealsRoute
  AppShellRecipesRoute: typeof AppShellRecipesRoute
  AppShellShoppingRoute: typeof AppShellShoppingRoute
  AppShellIndexRoute: typeof AppShellIndexRoute
}

const AppShellRouteChildren: AppShellRouteChildren = {
  AppShellMealsRoute: AppShellMealsRoute,
  AppShellRecipesRoute: AppShellRecipesRoute,
  AppShellShoppingRoute: AppShellShoppingRoute,
  AppShellIndexRoute: AppShellIndexRoute,
}

const AppShellRouteWithChildren = AppShellRoute._addFileChildren(
  AppShellRouteChildren,
)

interface AppRouteChildren {
  AppMealPageRoute: typeof AppMealPageRouteWithChildren
  AppRecipePageRoute: typeof AppRecipePageRouteWithChildren
  AppShellRoute: typeof AppShellRouteWithChildren
  AppImportRoute: typeof AppImportRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppMealPageRoute: AppMealPageRouteWithChildren,
  AppRecipePageRoute: AppRecipePageRouteWithChildren,
  AppShellRoute: AppShellRouteWithChildren,
  AppImportRoute: AppImportRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsAdminRoute: typeof SettingsAdminRoute
  SettingsDebugRoute: typeof SettingsDebugRoute
  SettingsSettingsRoute: typeof SettingsSettingsRoute
  SettingsAdminUserIdRoute: typeof SettingsAdminUserIdRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsAdminRoute: SettingsAdminRoute,
  SettingsDebugRoute: SettingsDebugRoute,
  SettingsSettingsRoute: SettingsSettingsRoute,
  SettingsAdminUserIdRoute: SettingsAdminUserIdRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  AuthPathRoute: AuthPathRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
